import { cn } from "@/utils/cn";
import { APPROVAL_STAGES, type ApprovalStageId } from "./stageUtils";

interface Props {
  counts: Record<ApprovalStageId, number>;
  activeStage?: ApprovalStageId | "";
  onStageClick?: (stage: ApprovalStageId) => void;
}

export function SolicitacaoPagamentoApprovalFlow({
  counts,
  activeStage = "",
  onStageClick,
}: Props) {
  return (
    <div className="rounded-xl border border-slate-200 bg-white shadow-card px-5 py-5 md:px-6 md:py-6">
      <div className="mb-5">
        <h2 className="text-sm font-semibold text-slate-800">Fluxo de aprovação</h2>
        <p className="text-xs text-slate-400 mt-0.5">
          Acompanhe em qual etapa cada solicitação se encontra no processo
        </p>
      </div>

      <div className="flex items-start gap-0 overflow-x-auto pb-1 [scrollbar-gutter:stable]">
        {APPROVAL_STAGES.map((stage, index) => {
          const Icon = stage.icon;
          const count = counts[stage.id];
          const isActive = activeStage === stage.id;
          const clickable = Boolean(onStageClick);

          return (
            <div key={stage.id} className="flex items-start min-w-0 flex-1">
              <button
                type="button"
                onClick={() => onStageClick?.(stage.id)}
                disabled={!clickable}
                className={cn(
                  "flex flex-col items-center text-center min-w-[120px] flex-1 px-1 transition-opacity",
                  clickable && "cursor-pointer hover:opacity-80",
                  !clickable && "cursor-default",
                  isActive && "opacity-100",
                )}
              >
                <div
                  className={cn(
                    "flex h-10 w-10 items-center justify-center rounded-full",
                    stage.iconBg,
                  )}
                >
                  <Icon className={cn("h-5 w-5", stage.iconColor)} />
                </div>

                <p className="mt-2.5 text-[11px] font-semibold text-slate-700 leading-tight px-1">
                  {stage.step}. {stage.title}
                </p>

                <span
                  className={cn(
                    "mt-1.5 inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold",
                    stage.pillBg,
                    stage.pillText,
                    isActive && "ring-2 ring-offset-1 ring-slate-300",
                  )}
                >
                  {count} {count === 1 ? "solicitação" : "solicitações"}
                </span>

                <p className="mt-1 text-[10px] text-slate-400 leading-tight px-1">
                  {stage.subtitle}
                </p>
              </button>

              {index < APPROVAL_STAGES.length - 1 && (
                <div className="flex-shrink-0 flex items-center pt-5 px-1">
                  <div className="w-6 border-t border-dashed border-slate-300 relative">
                    <span className="absolute -right-0.5 -top-[3px] text-slate-300 text-[8px]">
                      ›
                    </span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
